var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'label-box': !this.clearClass
}},[_c('div',{class:{
    'edit-label': !this.clearClass,
    'edit-label-init': this.clearClass
  },attrs:{"contenteditable":"true"},on:{"blur":_vm.blur}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/LabelBox/LabelBox.vue